<script lang="ts" setup>
  import { userAction } from '../../../shared/observability/userAction.ts';
  import { MessageView } from '../../../shared/ui/message-view';

  defineEmits<{ goToStart: [] }>();
</script>

<template>
  <MessageView
    message="This page does not exist."
    :user-action-name="userAction.notFoundGoToStart"
    @go-to-start="$emit('goToStart')"
  />
</template>
